import React, { useState } from 'react';
import './LandingFaq.css';
import wisbyLogo from '../../assets/logo.png';

// Colección `faqItems` que reúne los elementos utilizados en este flujo.
const faqItems = [
  {
    question: '¿Cómo tramito títulos accionarios?',
    answer: 'Inicia sesión, captura los datos de la sociedad y de los accionistas, revisa la vista previa y envía tu solicitud. Nuestro equipo dará seguimiento al proceso.',
  },
  {
    question: '¿Cómo se gestionan mis datos?',
    answer: 'La información se utiliza únicamente para preparar y administrar los servicios solicitados, conforme a nuestros controles de seguridad y aviso de privacidad.',
  },
  {
    question: '¿Quién lo avala?',
    answer: 'Cada trámite pasa por la revisión del equipo jurídico de Wisby y, cuando corresponde, por la validación del fedatario asignado.',
  },
  {
    question: '¿Puedo facturar?',
    answer: 'Sí. Durante la solicitud podrás indicar la razón social y proporcionar la constancia de situación fiscal de la empresa a facturar.',
  },
  {
    question: '¿Qué vigencia tienen los poderes?',
    answer: 'La vigencia depende del tipo de poder, su redacción y la legislación aplicable. El alcance definitivo se confirma durante la revisión jurídica.',
  },
  {
    question: '¿Cómo inicio sesión?',
    answer: 'Selecciona “Iniciar sesión” en el menú superior. Si todavía no tienes una cuenta, podrás registrarte desde esa misma pantalla.',
  },
];

// Componente `LandingFaq` que renderiza esta parte de la interfaz.
export default function LandingFaq({ onNavigate }) {
  // Estado local `openIndex` y su actualizador, usados para reflejar cambios en la interfaz.
  const [openIndex, setOpenIndex] = useState(null);

  // Función `toggleItem` que controla la navegación o visibilidad asociada.
  const toggleItem = (index) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <>
      <section className="landing-faq" aria-labelledby="landing-faq-title">
        <div className="landing-faq-inner">
          <header className="landing-faq-heading">
            <p>FAQ</p>
            <h2 id="landing-faq-title">
              Buena<br />
              <span>pregunta.</span>
            </h2>
          </header>

          <div className="landing-faq-list">
            {faqItems.map((item, index) => {
              // Indicador booleano `isOpen` que representa la condición señalada por su nombre.
              const isOpen = openIndex === index;
              // Valor intermedio `panelId` utilizado por la lógica de este bloque.
              const panelId = `landing-faq-panel-${index}`;

              return (
                <article className={`landing-faq-item${isOpen ? ' is-open' : ''}`} key={item.question}>
                  <button
                    type="button"
                    onClick={() => toggleItem(index)}
                    aria-expanded={isOpen}
                    aria-controls={panelId}
                  >
                    <span>{item.question}</span>
                    <span className="landing-faq-plus" aria-hidden="true" />
                  </button>
                  <div id={panelId} className="landing-faq-answer" hidden={!isOpen}>
                    <p>{item.answer}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <footer className="landing-footer">
        <div className="landing-footer-inner">
          <div className="landing-footer-brand">
            <img src={wisbyLogo} alt="Wisby" />
            <p>Wisby es una marca orgullosamente mexicana.</p>
          </div>

          <div className="landing-footer-column">
            <h3>Soluciones</h3>
            <button type="button" onClick={() => onNavigate('crear-accion')}>Tramitar acciones</button>
            <button type="button" onClick={() => onNavigate('crear-poder')}>Tramitar poderes</button>
            <button type="button" onClick={() => onNavigate('nosotros')}>Agenda una consultoría</button>
          </div>

          <div className="landing-footer-column">
            <h3>Contacto</h3>
            <button type="button" onClick={() => onNavigate('nosotros')}>Nosotros</button>
            <a href="https://maps.google.com" target="_blank" rel="noreferrer">Ubicación</a>
            <a href="mailto:contacto@wisby.mx">Contáctanos</a>
          </div>
        </div>
      </footer>
    </>
  );
}
